class BannerVideo {
    // 1. describe and create/initiate our object
    constructor() {
        this.section = document.querySelector('.banner');
        if (this.section) {
            this.videoDesktop = this.section.querySelector('.banner__video--desktop');
            this.videoMobile = this.section.querySelector('.banner__video--mobile');
        }
        if (this.section && this.videoDesktop && this.videoMobile) {
            this.events();
            window.addEventListener('scroll', () => this.handleScroll());
        }
    }

    // 2. events
    events() {
        if (window.innerWidth < 420) {
            this.videoMobile.play();
            this.videoDesktop.pause();
        } else {
            this.videoMobile.pause();
            this.videoDesktop.play();
        }
    }

    // 3. methods (function, action...)
    handleScroll() {
        const bannerVideoHeight = this.section.offsetHeight;
        const scrollPosition = window.scrollY;

        if (scrollPosition >= bannerVideoHeight) {
            if (window.innerWidth < 420) {
                this.videoMobile.pause();
            } else {
                this.videoDesktop.pause();
            }
        }
        else {
            if (window.innerWidth < 420) {
                this.videoMobile.play();
            } else {
                this.videoDesktop.play();
            }
        }
    }
}

export default BannerVideo;
